import {Endpoint} from '@eryxcoop/appyx-comm';

export default class EditCurrentAccountRiskClassificationEndpoint extends Endpoint {

    adaptValues({isHighRisk}) {
        return {
            has_no_overdue_tolerance: isHighRisk,
        }
    }
}
